/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import toast from "react-hot-toast";
import { ADD_TO_CART } from "../graphql/addToCart.mutation";
import { GET_ALL_CARTS } from "../graphql/getAllCarts.query";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IgetAllCartsMethods extends IPluginMethodMap {
  getAllCarts(): Promise<any>;
}

export class getAllCartsService implements IAgentPlugin {
  readonly methods: IgetAllCartsMethods;
  private exchangeRate: any = 1;

  constructor() {
    this.methods = {
      getAllCarts: this.getAllCarts.bind(this),
    };
  }

  async getAllCarts() {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_ALL_CARTS,
          variables: {},
          fetchPolicy: "network-only",
        });
        console.log("formatted res?.data?.getAllCarts", this.formatUserTable(res?.data?.getAllCarts));
        return {
          getAllCarts: res?.data?.getAllCarts,
          ultUsers: this.formatUserTable(res?.data?.getAllCarts),
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        const rawItems = item?.items ?? [];
        const totalCostumeAmt = parseFloat(item?.totalAmount ?? "0") || 0;

        let baseIndex = rawItems.findIndex(
          (itm: any) =>
            itm?.costumeFeature?.isBase === true ||
            itm?.isBase === true
        );
        if (baseIndex === -1) {
          baseIndex = 0;
        }

        const sumOtherTopups = rawItems.reduce((acc: number, itm: any, idx: number) => {
          if (idx === baseIndex) return acc;
          const topup = parseFloat(itm?.costumeValue?.topupPrice ?? itm?.valuePrice ?? itm?.featurePrice ?? "0") || 0;
          return acc + topup;
        }, 0);

        const basePrice = Math.max(0, totalCostumeAmt - sumOtherTopups);

        const minDownPaymentSum = rawItems.reduce(
          (sum: number, currentItem: any, idx: number) => {
            const isBase = idx === baseIndex;
            const typeMinDp = parseFloat(currentItem?.costumeType?.minDownPayment ?? "0") || 0;
            const downPayment = parseFloat(
              currentItem?.costumeValue?.minDownPayment || currentItem?.valuePrice || "0"
            ) || (isBase ? typeMinDp : 0);
            return sum + downPayment;
          },
          0
        );
        console.log("printitem", item);
        const formattedItems = rawItems.map((itm: any) => ({
          costumeType: itm?.costumeType?.id ?? itm?.costumeType ?? "",
          costumeFeature: itm?.costumeFeature?.id ?? itm?.costumeFeature ?? "",
          costumeAttribute: itm?.costumeAttribute?.id ?? itm?.costumeAttribute ?? "",
          costumeValue: itm?.costumeValue?.id ?? itm?.costumeValue ?? "",
        }));

        return {
          id: item?._id,
          sectionName: item?.section?.name ?? item?.section ?? "Null",
          sectionOptTypeName: item?.section?.costumeTypes?.[0]?.name ?? "-",
          totalAmt: item?.totalAmount ?? "0",
          deleteIcon: true,
          discountedAmount: 0,
          content: item,
          minDownPayment: minDownPaymentSum,
          boxItems: rawItems.map((itm: any, idx: number) => {
            const isBase = idx === baseIndex;
            const typeMinDp = parseFloat(itm?.costumeType?.minDownPayment ?? "0") || 0;
            const itemMinDp =
              parseFloat(itm?.costumeValue?.minDownPayment ?? itm?.valuePrice ?? "0") ||
              (isBase ? typeMinDp : 0);
            const itemPrice = isBase
              ? basePrice
              : parseFloat(itm?.costumeValue?.topupPrice ?? itm?.valuePrice ?? itm?.featurePrice ?? "0") || 0;

            return {
              costumeType: itm?.costumeType?.id ?? (typeof itm?.costumeType === "string" ? itm?.costumeType : ""),
              costumeFeature: itm?.costumeFeature?.id ?? (typeof itm?.costumeFeature === "string" ? itm?.costumeFeature : ""),
              costumeAttribute: itm?.costumeAttribute?.id ?? (typeof itm?.costumeAttribute === "string" ? itm?.costumeAttribute : ""),
              costumeValue: itm?.costumeValue?.id ?? (typeof itm?.costumeValue === "string" ? itm?.costumeValue : ""),
              costumeFeatureName: itm?.costumeFeature?.name ?? itm?.costumeFeature ?? "",
              costumeValueName: itm?.costumeValue?.name ?? itm?.costumeValue ?? "",
              costumeAttributeName: itm?.costumeAttribute?.name ?? itm?.costumeAttribute ?? "",
              costumeTypeName: itm?.costumeType?.name ?? itm?.costumeType ?? "",
              isBase,
              minDownPayment: itemMinDp,
              price: itemPrice,
            };
          }),
          items: {
            presentation: item?.presentation?.id ?? item?.presentation ?? "",
            section: item?.section?.id ?? item?.section ?? "",
            items: formattedItems,
            referal: item?.referal,
            address: {
              addressLine1: item?.address?.addressLine1,
              city: item?.address?.city,
            },
            delivery: {
              isOpted: item?.delivery?.isOpted ?? false,
            },
            availableTime: item?.availableTime,
          },
        };
      });
    console.log("_rowData106", _rowData);
    return _rowData;
  }
}
